:host {
  display: block;
  position: fixed;
  top: 20px;
  left: 20px;
  width: 400px;
  height: 500px;
  z-index: 1000;
  background-color: var(--ux-color-background-default);
  border-radius: var(--ux-border-radius-large);
  overflow: hidden;
  box-shadow: var(--ux-shadow-large);
}

.chat-manager {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--ux-color-background-default);

  &.minimized {
    height: auto;
  }
}

.window-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: var(--ux-color-background-light);
  border-bottom: 1px solid var(--ux-color-border);

  .title {
    font-size: var(--ux-font-size-small);
    font-weight: var(--ux-font-weight-medium);
    color: var(--ux-color-text);
  }
}

.content {
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px); // subtract window controls height
  overflow: hidden;
}

.cases-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-bottom: 1px solid var(--ux-color-border);
  background: var(--ux-color-background-white);

  h2 {
    margin: 0;
    font-size: var(--ux-font-size-normal);
    font-weight: var(--ux-font-weight-medium);
  }
}

.cases-list {
  list-style: none;
  padding: 0.5rem;
  margin: 0;
  overflow-y: auto;
  flex-shrink: 0;
  max-height: 200px;
  background: var(--ux-color-background-white);
}

.case-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 4px;
  background: var(--ux-color-background-light);
  cursor: pointer;
  font-size: var(--ux-font-size-small);

  &:hover {
    background: var(--ux-color-background-hover);
  }

  &.active {
    background: var(--ux-color-background-selected);
  }

  .case-title {
    flex: 1;
  }

  .case-status {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}

.chats-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top: 1px solid var(--ux-color-border);
}

.chats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: var(--ux-color-background-white);
  border-bottom: 1px solid var(--ux-color-border);

  h2 {
    margin: 0;
    font-size: var(--ux-font-size-normal);
    font-weight: var(--ux-font-weight-medium);
  }

  .actions {
    display: flex;
    gap: 0.5rem;
  }
}

.chat-list {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;
  background: var(--ux-color-background-white);
}

.chat-list-item {
  padding: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 4px;
  background: var(--ux-color-background-light);
  cursor: pointer;
  font-size: var(--ux-font-size-small);

  &:hover {
    background: var(--ux-color-background-hover);
  }

  &.active {
    background: var(--ux-color-background-selected);
  }

  h4 {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: var(--ux-font-size-small);
    font-weight: var(--ux-font-weight-medium);
  }

  .chat-preview {
    margin-top: 0.25rem;
    font-size: var(--ux-font-size-small);
    color: var(--ux-color-text-secondary);
  }

  .chat-meta {
    margin-top: 0.25rem;
    font-size: var(--ux-font-size-tiny);
    color: var(--ux-color-text-tertiary);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
  color: var(--ux-color-text-secondary);
  height: 100%;

  h3 {
    margin: 0.5rem 0 0.25rem;
    font-size: var(--ux-font-size-small);
  }

  p {
    margin: 0;
    font-size: var(--ux-font-size-small);
  }
}

.loading-indicator {
  display: flex;
  justify-content: center;
  padding: 1rem;
}

.debug-panel {
  padding: 0.75rem;
  background: var(--ux-color-background-light);
  border-top: 1px solid var(--ux-color-border);
  font-size: var(--ux-font-size-small);

  h3 {
    margin: 0 0 0.5rem;
    font-size: var(--ux-font-size-small);
    color: var(--ux-color-text-secondary);
  }

  pre {
    margin: 0;
    padding: 0.5rem;
    background: var(--ux-color-background-white);
    border-radius: 4px;
    font-size: var(--ux-font-size-tiny);
    overflow: auto;
    max-height: 100px;
  }
}

